import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import {isMobile} from 'react-device-detect'; 

interface MobileContextInterface {
    isMobileWidth: boolean | null;
    isMobileDevice: boolean | null;
}

const MobileContext = createContext<MobileContextInterface>({
    isMobileWidth: null,
    isMobileDevice: null,
});

export const MobileProvider = ({ children }) => {
    const [isMobileWidth, setIsMobileWidth] = useState(null);
    const [isMobileDevice, setIsMobileDevice] = useState(null);

    useEffect(() => {
        setIsMobileDevice(isMobile);
        if (window) {
            window.addEventListener("resize", handleResize);
            handleResize();
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []);

    const handleResize = useCallback(() => {
        if (window) {
            const width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            
            if (width < 991) {
                setIsMobileWidth(true);
            } else if (width >= 991) {
                setIsMobileWidth(false);
            }
        }
    }, [isMobileWidth]);

    return (
        <MobileContext.Provider value={{isMobileWidth, isMobileDevice}}>
            { children}
        </MobileContext.Provider>);
}

export const useIsMobile = () => useContext(MobileContext);